import Axios from "axios";
import { tallyCrudRepAxios, tallyStaticRepAxios } from "src/config/axios.config";

import {
    GET_PURCHASE_INVOICE_LIST,
    GET_PURCHASE_INVOICE_LIST_SUCCESS,
    GET_PURCHASE_INVOICE_LIST_FAILURE,
    GET_INVOICE_LIST_BY_TYPE_SUCCESS,
    GET_INVOICE_LIST_BY_TYPE_FAILURE,
    GET_INVOICE_LIST_BY_TYPE,
    GET_PURCHASE_GROUP_LIST,
    GET_PURCHASE_GROUP_LIST_SUCCESS,
    GET_PURCHASE_GROUP_LIST_FAILURE,
} from "../actionTypes";
const getPurchaseInvoiceList = (ledgerName,vocherType) => (dispatch) => {
  // Intitial Dispatch // can be used to show loader
  dispatch({
    type: GET_PURCHASE_INVOICE_LIST,
  });

  return tallyStaticRepAxios
    .get(`questions/getInvocieNumabersByLedgerName?ledgerName=${ledgerName}&vocherType=${vocherType}`)
    .then(
      (res) =>
        dispatch({
          type: GET_PURCHASE_INVOICE_LIST_SUCCESS,
          payload: res.data,
        }),
      (err) =>
        dispatch({
          type: GET_PURCHASE_INVOICE_LIST_FAILURE,
          payload: err,
        })
    );
};

const getInvoiceListByType = (vocherType) => (dispatch) => {
    // Intitial Dispatch // can be used to show loader
    dispatch({
      type: GET_INVOICE_LIST_BY_TYPE,
    });
  
    return tallyStaticRepAxios
      .get(`reports/getAllListOfInvocieByVocherType?vocherType=${vocherType}`)
      .then(
        (res) =>
          dispatch({
            type: GET_INVOICE_LIST_BY_TYPE_SUCCESS,
            payload: res.data,
          }),
        (err) =>
          dispatch({
            type: GET_INVOICE_LIST_BY_TYPE_FAILURE,
            payload: err,
          })
      );
  };

  const getPurchaseGroupList = (type) => (dispatch) => {
    // Intitial Dispatch // can be used to show loader
    dispatch({
      type: GET_PURCHASE_GROUP_LIST,
    });
  
    return tallyCrudRepAxios
      .get(`tally/vouchers/getVoucherTypeNamesByParentName?parentType=${type}`)
      .then(
        (res) =>
          dispatch({
            type: GET_PURCHASE_GROUP_LIST_SUCCESS,
            payload: res.data,
          }),
        (err) =>
          dispatch({
            type: GET_PURCHASE_GROUP_LIST_FAILURE,
            payload: err,
          })
      );
  };

export { getPurchaseInvoiceList,getInvoiceListByType ,getPurchaseGroupList };
